import { createTheme } from '@mui/material/styles';
import { varColor, varFont } from '~/themes/themeVariables';
import { muiOverride } from '~/themes/muiOverride';

/**
 * All components of MUI following this theme
 */
export const customTheme = createTheme({
  spacing: 4,
  typography: {
    fontFamily: varFont.primary,
    fontSize: 14,
    button: {
      textTransform: 'none',
      fontSize: 14,
    },
  },

  palette: {
    primary: {
      light: varColor.primary,
      main: varColor.primary,
      dark: varColor.primary,
      contrastText: varColor.white,
    },
    secondary: {
      main: varColor.white,
      contrastText: varColor.black,
    },
    info: {
      main: varColor.info,
      contrastText: varColor.white,
    },
    error: {
      light: varColor.error,
      main: varColor.textRequired,
      dark: varColor.error,
      contrastText: varColor.white,
    },
    text: {
      primary: varColor.textPrimary,
      secondary: varColor.textSecondary,
    },
    divider: varColor.divider,
    background: {
      default: varColor.bgPrimary,
      paper: varColor.bgSecondary,
    },
  },

  components: {
    ...muiOverride,
  },
});
